import { contains } from './index'

const APP_ENV = () => {
    if (typeof window === 'undefined')
        return 'production'
    
    return contains(window.location.href, '-dev.') || contains(window.location.href, 'localhost') ? 'development' :
        contains(window.location.href, '-test.') ? 'testing' :
        'production'
}

export const APP_IN_DEV = APP_ENV() === 'development'
export const APP_IN_TEST = APP_ENV() === 'testing'
export const APP_IN_PROD = APP_ENV() === 'production'

export const DJANGO_URL = //APP_IN_PROD ?
    'https://wcms.canadiandiscovery.com' //:
    //'https://wcms-test.canadiandiscovery.com'

export const AUTH_URL = APP_IN_PROD ?
    'https://authenticate.canadiandiscovery.com' :
    'https://auth-opsp.canadiandiscovery.com'

export const WEBHOST_URL = 'https://webfiles.canadiandiscovery.com'

export const API_URL = APP_IN_PROD ?
    'https://api.canadiandiscovery.com' :
    'https://api-test.canadiandiscovery.com'

export const ARCGIS_URL = APP_IN_PROD ?
    'http://arcgis.canadiandiscovery.com' :
    'http://arcgis-test.canadiandiscovery.com'
